import i18next from 'i18next';
import Paragraph from '../../components/Paragraph/Paragraph';
import { APPLICATION_TYPE } from '../../constants/sessionStorage';
import { APPLICATION_TYPE_STRING } from '../constants';
import { retrieveFromSessionStorage } from './sessionStorageHelper';

const isUTMAAccount = () =>
  retrieveFromSessionStorage(APPLICATION_TYPE) === APPLICATION_TYPE_STRING[5];

export const utmaCountryOfCitizenshipNote = (country, brokerCode) => {
  if (!isUTMAAccount()) {
    return;
  }

  if (country !== 'USA') {
    return (
      <Paragraph mt={12}>
        <strong>{i18next.t('common.note')}</strong>:{' '}
        {i18next.t('secureIdentity.utmaNote', { brokerCode })}
      </Paragraph>
    );
  }

  return null;
};

export const utmaCountryOfCitizenshipButtonDisable = (country) => {
  if (!isUTMAAccount()) {
    return false;
  }

  if (country !== 'USA') {
    return true;
  }

  return false;
};
